import _ from 'lodash';
import api from '@src/api';
import axios from 'axios';

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    selectedWorkout: null,
    currentCircuit: null,
    currentExercise: null,
    currentCircuitIndex: 0,
    currentExerciseIndex: 0,
    currentSetIndex: 0,
    prevExercise: null,
    nextExercise: null,
    isBeginningOfWorkout: false,
    restType: '',
    isTransitionPeriod: false,
    isLastCircuit: false,
    isLastExercise: false,
    isLoadingExercise: false,
    completedWorkoutElements: 0,
    completedWorkoutDuration: 0,
    currentExerciseSetTime: 0,
    clientSetDirections: null,
    showCircuitIntro: false,
    isWorkoutUpdate: true,
    afterSetRest: 0,
    skipRestPeriod: false,
  };
}

export const getters = {
  isEndOfWorkout: (state) => {
    const sets = state.currentExercise.setDirections;
    return state.isLastCircuit && state.isLastExercise && state.currentSetIndex === sets.length;
  },
};

export const mutations = {
  setSelectedWorkout(state, value) {
    state.selectedWorkout = value;
  },
  setCurrentExerciseSetTime(state, value) {
    state.currentExerciseSetTime = value;
  },
  setCurrentCircuit(state, value) {
    const i = state.currentCircuitIndex;
    const circuits = state.selectedWorkout.programDayWorkout.circuits;
    const circuitLength = circuits.length;

    if (i + 1 >= circuitLength) {
      state.isLastCircuit = true;
    }

    if (value) {
      state.currentCircuit = value;
    } else {
      if (i < circuitLength) {
        state.isLastCircuit = false;
        state.currentCircuit = circuits[i > 0 ? i : 0];
      }
    }
  },
  setCurrentExercise(state, value) {
    const i = state.currentExerciseIndex;
    const exercises = state.currentCircuit.exercises;
    const exerciseLength = exercises.length;

    if (i + 1 >= exerciseLength) {
      state.isLastExercise = true;
    }

    if (value) {
      state.currentExercise = value;
    } else if (i < 0) {
      const circuits = state.selectedWorkout.programDayWorkout.circuits;
      const prevCircuit = circuits[state.currentCircuitIndex - 1];

      if (prevCircuit) {
        const exerciseIndex = prevCircuit.exercises.length - 1;
        state.currentExercise = prevCircuit.exercises[exerciseIndex];
      }

      state.isLastExercise = true;
    } else {
      if (i < exerciseLength) {
        state.isLastExercise = false;
        state.currentExercise = exercises[i];
      }
    }
  },
  setCurrentCircuitIndex(state, value) {
    const circuitsLength = state.selectedWorkout.programDayWorkout.circuits.length;
    state.currentCircuitIndex = value < circuitsLength ? value : circuitsLength > 0 ? circuitsLength - 1 : value > 0 ? value : 0;
  },
  setCurrentExerciseIndex(state, value) {
    const exercisesLength = state.currentCircuit?.exercises.length || 0;
    state.currentExerciseIndex =
      value < exercisesLength ? value : exercisesLength > 0 ? exercisesLength - 1 : value > 0 ? value : 0;
  },
  setCurrentSetIndex(state, value) {
    state.currentSetIndex = value;
  },
  setPrevCircuit(state) {
    if (state.currentCircuitIndex > 0) {
      const circuits = state.selectedWorkout.programDayWorkout.circuits;
      if (circuits.length > 1) {
        const i = circuits.findIndex((circuit) => circuit._id === state.currentCircuit._id);
        state.prevCircuit = circuits[i - 1];
      }
    }
  },
  setNextCircuit(state) {
    const circuits = state.selectedWorkout.programDayWorkout.circuits;
    const i = state.currentCircuitIndex;
    state.nextCircuit = circuits[i + 1];
  },
  setPrevExercise(state) {
    if (state.isBeginningOfWorkout) {
      state.prevExercise = null;
    } else {
      const i = state.currentExerciseIndex;
      const circuits = state.selectedWorkout.programDayWorkout.circuits;
      const exercises = state.currentCircuit.exercises;
      const isFirstSet = state.currentSetIndex === 0;

      // If it's the first Set, we grab the last Exercise in the previous Circuit
      if (isFirstSet) {
        const prevCircuit = circuits[state.currentCircuitIndex - 1];
        if (prevCircuit) {
          state.prevExercise = prevCircuit.exercises[prevCircuit.exercises.length - 1];
        }
      } else if (i < exercises.length && state.currentSetIndex > 0) {
        state.prevExercise = state.currentExercise;
      } else if (i > 0 && isFirstSet) {
        state.prevExercise = exercises[i - 1];
      }
    }
  },
  setNextExercise(state) {
    const i = state.currentExerciseIndex;
    const exercises = state.currentCircuit.exercises;
    const isLastSet = state.currentSetIndex + 1 >= state.currentExercise.setDirections.length;
    const isLastExercise = i + 1 >= exercises.length;
    const isLastCircuit = state.currentCircuitIndex + 1 >= state.selectedWorkout.programDayWorkout.circuits.length;

    if (isLastSet && i + 1 < exercises.length) {
      state.nextExercise = exercises[i + 1];
    } else if (isLastSet && isLastExercise && !isLastCircuit) {
      state.nextExercise = null;
    } else {
      state.nextExercise = exercises[i < 0 ? 0 : i];
    }
  },
  setForceEndWorkout(state) {
    state.isLastCircuit = true;
    state.isLastExercise = true;
  },
  setRestType(state, value) {
    state.restType = value;
  },
  setIsTransitionPeriod(state, value) {
    state.isTransitionPeriod = value;
  },
  setUpdatePostWorkoutReview(state, value) {
    const workoutClone = _.cloneDeep(state.selectedWorkout);
    workoutClone.programDayWorkout.clientInput.postWorkoutReview = value;
    state.selectedWorkout = workoutClone;
  },
  setCompletedWorkoutElements(state, value) {
    state.completedWorkoutElements = value;
  },
  setCompletedWorkoutDuration(state, value) {
    state.completedWorkoutDuration = value;
  },
  setIsLoadingExercise(state, value) {
    state.isLoadingExercise = value;
  },
  setClientSetDirections(state, value) {
    state.clientSetDirections = value;
  },
  setShowCircuitIntro(state, value) {
    state.showCircuitIntro = value;
  },
  setIsWorkoutUpdated(state, value) {
    state.isWorkoutUpdate = value;
  },
  setAfterSetRest(state, value) {
    state.afterSetRest = value;
  },
  setIsBeginningOfWorkout(state, value) {
    if (value !== undefined) {
      state.isBeginningOfWorkout = value;
    } else {
      state.isBeginningOfWorkout = !state.currentCircuitIndex && !state.currentExerciseIndex && !state.currentSetIndex;
    }
  },
  setSkipRestPeriod(state, value) {
    state.skipRestPeriod = value;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  startWorkout(ctx, { programDayId }) {
    if (programDayId) {
      const payload = { programDay_id: programDayId };

      return axios
        .put(api.URL_START_WORKOUT, payload)
        .then(async (res) => {
          const programWorkout = res.data.programDayWorkout;
          const workoutProgress = programWorkout.clientInput.workoutProgress;
          await ctx.commit('setSelectedWorkout', res.data);
          await ctx.commit('setCurrentCircuitIndex', workoutProgress.circuitIndex);
          await ctx.commit('setCurrentExerciseIndex', workoutProgress.exerciseIndex);
          await ctx.commit('setCurrentSetIndex', 0);
          await ctx.commit('setIsBeginningOfWorkout');
          await ctx.commit('setCurrentCircuit', programWorkout.circuits[workoutProgress.circuitIndex]);
          await ctx.commit('setCurrentExercise', res.data.startingExercise);
          ctx.commit('setNextExercise');
          ctx.commit('setNextCircuit');
          ctx.commit('setCompletedWorkoutElements', workoutProgress.completedWorkoutElements);
          ctx.commit('setCompletedWorkoutDuration', workoutProgress.workoutDurationSeconds);
          ctx.commit('setIsWorkoutUpdated', true);

          if (workoutProgress.completedWorkoutElements > 0) {
            ctx.commit('setPrevExercise');
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      console.error(`invalid params (programDayId) : (${programDayId})`);
    }
  },
  updateWorkout(ctx, { programDayId, workoutProgress, currentExercise, setDirections, currentExerciseIndex }) {
    if (
      programDayId &&
      workoutProgress &&
      currentExercise &&
      setDirections &&
      currentExerciseIndex !== undefined &&
      currentExerciseIndex !== null
    ) {
      const validCircuitIndex =
        ctx.state.currentCircuitIndex < 0
          ? 0
          : ctx.state.currentCircuitIndex > state.currentCircuit.exercises.length
          ? ctx.state.currentCircuitIndex + 1
          : ctx.state.currentCircuitIndex;
      const validExerciseIndex =
        ctx.state.currentCircuitIndex > state.currentCircuit.exercises.length
          ? 0
          : currentExerciseIndex > state.currentCircuit.exercises.length
          ? state.currentCircuit.exercises.length > 0
            ? state.currentCircuit.exercises.length - 1
            : 0
          : 0;

      const payload = {
        programDay_id: programDayId,
        workoutProgress,
        currentExercise: {
          ...currentExercise,
          setDirections: setDirections,
          circuitIndex: validCircuitIndex ?? 0,
          exerciseIndex: validExerciseIndex ?? 0,
        },
      };
      return axios
        .put(api.URL_UPDATE_WORKOUT, payload)
        .then((res) => {
          ctx.commit('setIsWorkoutUpdated', true);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      console.error(`invalid params (programDayId, workoutProgress) : (${programDayId}, ${workoutProgress})`);
    }
  },
  completeWorkout(ctx, { programDayId, workoutProgress, postWorkoutReview, setDirections }) {
    if (programDayId && workoutProgress && postWorkoutReview) {
      const payload = {
        programDay_id: programDayId,
        totalCompletedWorkoutElements: workoutProgress.completedElements,
        totalWorkoutDurationSeconds: workoutProgress.totalSeconds,
        postWorkoutReview: postWorkoutReview,
      };

      return axios
        .put(api.URL_COMPLETE_WORKOUT, payload)
        .then((res) => {
          ctx.commit('setIsWorkoutUpdated', true);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      console.error(
        `invalid params (programDayId, workoutProgress, postWorkoutReview) : (${programDayId}, ${workoutProgress}, ${postWorkoutReview})`
      );
    }
  },
};
